import { Component, Input } from '@angular/core';

export interface IConsolShipmentMilestone {
    key?: string;
    label: string;
    days: number;
    startDate?: string;
    endDate?: string;
}

@Component({
    selector: 'eci-consolidate-shipment-milestones',
    templateUrl: './consolidate-shipment-milestones.component.html',
    styleUrls: ['./consolidate-shipment-milestones.component.scss']
})
export class ConsolidateShipmentMilestonesComponent {

    readonly title = 'Consol Shipment Milestones';

    @Input() milestones: IConsolShipmentMilestone[] | null = null;
}
